import { ConsoleSqlOutlined } from '@ant-design/icons';
import { CCol, CFormCheck, CFormInput, CFormTextarea, CRow, CTooltip, CButton, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CFormSelect, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody } from '@coreui/react';
import { motion } from 'framer-motion';
import { Check, CircleAlertIcon, Plus, Info } from 'lucide-react';
import React, { useEffect, useState } from 'react';

import LabCRUD from "../../services/general/LabsAPI.api.js";
import MedicineCRUD from "../../services/general/Medication.api";
import ImagingInformation from "../../services/general/ImagingAPI.api.js";
import QuestionDropdownPreview from './QuestionDropdownPreview';
import QuestionDropdownOptions from './QuestionDropdownOptions';
import QuestionDropdownTSTab from './QuestionDropdownTSTab';
import { SaveActivity } from './save-activity.jsx';

const QuestionDropdownBuilder = ({ mode, addQuestions, allQuestions, dropdownInput, setDropdownInput, selectedEditDiagnosisQuestion,
    fetchedQuestions, setCallAddFromMade, diagnosisData, selectedDiagnosis, setIsOpenModal, saveMode = "diagnosis", saveQuestion, selectedOption, styling, diagnosisForNested, setIsBuilderVisible, setQuestionType, addFormMade }) => {
    //  currentTextInputs, setCurrentTextInputs,

    const [activeTab, setActiveTab] = useState("basic")
    const [selectedOptionsCondition, setSelectedOptionsCondition] = useState(null)
    const [previewActiveTab, setPreviewActiveTab] = useState("question")

    const [selectedOptionInfo, setSelectedOptionsInfo] = useState(null)
    const [selectedOptionValues, setSelectedOptionValues] = useState([])

    const [isPageLoading, setIsPageLoading] = useState(false)
    const [linkQuestion, setLinkQuestion] = useState(false)
    const [labList, setLabList] = useState([]);
    const [medicationData, setMedicationData] = useState([]);
    const [imagingData, setImagingData] = useState([]);
    const [showRemark, setShowRemark] = useState(true);
    const [fillYesNo, setFillYesNo] = useState(false);
    const [selectOption, setSelectOption] = useState([]);
    const [diagnosiss, setDiagnosiss] = useState([]);
    const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);
    const [currentOptionIndex, setCurrentOptionIndex] = useState(null); // to track which option is linking a question

    const [questionObj, setQuestionObj] = useState({
        id: Date.now(),
        label: "",
        answer: "",
        condition: null,
        type: "dropdown",
        isMultiple: false,
        toolTipValue: "",
        options: [],
        freeType: "",
        showFreeTypeInAssessment: false,
        historyOfDiagnosis: false,
    });


    const [currentTextInputs, setCurrentTextInputs] = useState({
        id: Date.now(),
        label: "",
        answer: "",
        isTextArea: true,
        isTextInputText: false,
        toolTipValue: "",
        isPretextToShow: false,
        type: "input",
        preText: "",
        postText: "",
        isRemark: "",
        remarkToShow: false,
        isPostTextToShow: false,
        isValueShowInAssessment: false,
        condition: null,
    });



    const [linkedQuestionObj, setLinkedQuestionObj] = useState({});

    useEffect(() => {
        // console.log("In use Effect 1", linkedQuestionObj)
        // console.log("***************************")
        // console.log(dropdownInput)
        // console.log(mode)
        if (mode == "Edit") {
            console.log("In Edit")
            console.log("saveMode")
            console.log(dropdownInput)
            setQuestionObj(dropdownInput)
        } else {

            if (saveMode == "options") {
                console.log("In Options")
                setLinkedQuestionObj(dropdownInput)
            }
        }
        handleLabData()
        getData()
        getImagingData()
        handleDiagnosis()
    }, [dropdownInput])

    const openQuestionModal = (index) => {
        console.log("Opening here")
        console.log(openQuestionModal)
        setCurrentOptionIndex(index);
        setIsQuestionModalOpen(true);

        console.log(index)

        setLinkedQuestionObj((prev) => ({
            ...dropdownInput,
            options: dropdownInput.options.map((opt, idx) =>
                idx === index ? { ...opt, linkQuestion: prev } : opt
            ),
        }));
    };


    const handleLabData = async () => {
        // setIsPageLoading(true);
        try {
            let labData = await LabCRUD("GETALL", "{}");
            labData = JSON.parse(labData.d)?.Data;
            // Simulate fetching data
            setLabList(labData);
        } catch (error) {

        }
    };

    const getData = async () => {
        setIsPageLoading(true)
        let allMedicines = await MedicineCRUD("GET")

        let formattedData
        formattedData = JSON.parse(allMedicines.d)?.Data;
        formattedData = formattedData.map(item => {
            return {
                ...item,
                Data: JSON.parse(item.Data)
            };
        });
        if (formattedData) {

            let medicationData = formattedData.map(item => (item.Data))
            setMedicationData(medicationData);
        }
        setIsPageLoading(false)
    }

    const getImagingData = async () => {
        setIsPageLoading(true)
        try {
            const data = await ImagingInformation("GET_ALL");
            if (data) {
                const formattedData = JSON.parse(data.d)?.Data;
                const allFormattedData = formattedData.map((item) => {
                    let parsedKeywords;
                    try {
                        if (item.Keywords) {
                            parsedKeywords = JSON.parse(item.Keywords);
                        } else {
                            parsedKeywords = [];
                        }
                    } catch (e) {
                        parsedKeywords = item.Keywords ? item.Keywords.split(',').map(keyword => keyword.trim()) : [];
                    }

                    return {
                        ...item,
                        // Keywords:[]
                        Keywords: JSON.parse(JSON.parse(item.Keywords))
                    };
                });
                setImagingData(allFormattedData.sort((a, b) => a.Priority - b.Priority));
            }
        } catch (error) {
            console.error("Error fetching imaging data", error);
        } finally {
            setIsPageLoading(false)
        }
    };


    const handleDiagnosis = () => {
        const diagnosis = diagnosisData?.filter(dig => dig.value !== selectedDiagnosis.value)
        setDiagnosiss(diagnosis)

    }
    const handleAddOptions = () => {
        const optionFormat = {
            id: Date.now(), label: "", value: "", remark: "", showInAssessment: false, answerText: "", attachOrders: false, suggestDiagnosis: false, diagnosis: null, orders: null, providerInstruction: null, linkedQuestion: null, linkedAssessment: null
        }
        setQuestionObj((p) => ({
            ...p,
            options: [optionFormat, ...p.options],
        }))
    }

    const handleChangeOption = (e, idx) => {
        e.preventDefault();
        const { name, value } = e.target;
        const formattedValue = value.trim().replace(/\s+/g, '');

        setQuestionObj((prev) => {
            const updatedOptions = [...prev.options];
            updatedOptions[idx] = {
                ...updatedOptions[idx],
                [name]: value,
                ...(name === 'label' && { value: formattedValue })
            };
            return {
                ...prev,
                options: updatedOptions,
            };
        });
    };

    const handleClose = () => {
        if (saveMode === "options") {

            setIsOpenModal(false);
        } else {
            setIsOpenModal(false);
        }
    }

    const handleSave = () => {
        console.log("Save Mode", saveMode);
        if (saveMode === "options") {
            console.log("handleSave==========>", linkedQuestionObj);
            console.log(questionObj);

            const updatedQuestionObj = {
                ...questionObj,
                options: questionObj.options.map((opt, idx) => {
                    if (idx === currentOptionIndex) {
                        // Check if linkedQuestion is an object or a list
                        const linkedQuestion = opt.linkedQuestion;
                        return {
                            ...opt,
                            linkedQuestion: Array.isArray(linkedQuestion)
                                ? [...linkedQuestion, linkedQuestionObj] // If it's a list, append the object
                                : linkedQuestion
                                    ? [linkedQuestion, linkedQuestionObj] // If it's an object, convert to list and append
                                    : [linkedQuestionObj], // If it doesn't exist, initialize as a list with the object
                        };
                    }
                    return opt;
                }),
            };

            console.log("save update option", updatedQuestionObj);
            saveQuestion(updatedQuestionObj);
        } else {
            console.log("Saving here in else condition");
            saveQuestion(questionObj);
            setCallAddFromMade(true);
        }
                    SaveActivity("Added a question in Form Builder")
    };
    const handleAutoSave = (shouldModelCall = false) => {
        console.log("Save Mode", saveMode);
        if (saveMode === "options") {
            console.log("handleSave==========>", linkedQuestionObj);
            console.log(questionObj);

            const updatedQuestionObj = {
                ...questionObj,
                options: questionObj.options.map((opt, idx) => {
                    if (idx === currentOptionIndex) {
                        // Check if linkedQuestion is an object or a list
                        const linkedQuestion = opt.linkedQuestion;
                        return {
                            ...opt,
                            linkedQuestion: Array.isArray(linkedQuestion)
                                ? [...linkedQuestion, linkedQuestionObj] // If it's a list, append the object
                                : linkedQuestion
                                    ? [linkedQuestion, linkedQuestionObj] // If it's an object, convert to list and append
                                    : [linkedQuestionObj], // If it doesn't exist, initialize as a list with the object
                        };
                    }
                    return opt;
                }),
            };

            console.log("save update option", updatedQuestionObj);
            saveQuestion(updatedQuestionObj, shouldModelCall);
        } else {
            console.log("Saving here in else condition");
            saveQuestion(questionObj, shouldModelCall);
            setCallAddFromMade(true);
        }
    };


    useEffect(() => {

        console.log("In use Effect 2")
        console.log(selectedOptionsCondition)
        if (selectedOptionsCondition) {
            const allOptionsValues = [...allQuestions, ...fetchedQuestions?.questionData]
            const findSelectedValuesOfSelectedOptions = allOptionsValues.find(item => item?.id === selectedOptionsCondition.value)
            setSelectedOptionsInfo(findSelectedValuesOfSelectedOptions)
            const allOptionForthis = findSelectedValuesOfSelectedOptions?.options?.map(item => item.label)
            setSelectedOptionValues(allOptionForthis)
        }
    }, [selectedOptionsCondition, allQuestions, fetchedQuestions])
    return (
      <motion.div className="custom-form-builder-theme__builder-modal rounded-3 position-relative" style={{ width: saveMode == 'options' ? '100%' : '80%', height: '85%', overflowY: 'scroll' }} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <div className="d-flex align-items-center justify-content-center flex-column w-100">
          <div style={{ zIndex: 5000 }} className="custom-form-builder-theme__builder-sticky justify-content-center position-sticky top-0 left-0 w-full px-4 pb-4">
            <div className="custom-form-builder-theme__builder-header d-flex mt-4 justify-content-between border-top border-bottom align-items-center ">
              <p className="p-2 m-0 text-center w-100  ">Form Builder</p>
              <p className="p-2 m-0 text-center w-100">Preview</p>
            </div>
          </div>

          <div className="w-100 h-100 d-flex align-items-start  gap-2 outline ">
            <CCol className="custom-form-builder-theme__builder-column h-100 d-flex align-items-center justify-content-center flex-column gap-2 border-end">
              <div className="w-100 h-100  ">
                <div className="w-100 d-flex align-items-center justify-content-center  ">
                  <CNav variant="pills" role="tablist">
                    <CNavItem>
                      <CNavLink active={activeTab === 'basic'} onClick={() => setActiveTab('basic')}>
                        Basics
                      </CNavLink>
                    </CNavItem>
                    <CNavItem>
                      <CNavLink active={activeTab === 'options'} onClick={() => setActiveTab('options')}>
                        Options
                      </CNavLink>
                    </CNavItem>
                    <CNavItem>
                      <CNavLink active={activeTab === 'assessment'} onClick={() => setActiveTab('assessment')}>
                        Treatment Shell
                      </CNavLink>
                    </CNavItem>
                  </CNav>
                </div>
                {activeTab === 'basic' && (
                  <div className="d-flex">
                    <div className="w-100 h-100 d-flex gap-1 flex-column p-4 " visible={activeTab === 'basic'}>
                      {/* basic content */}
                      <div className="w-100">
                        <p className="font-weight-medium mb-2">Enter question</p>
                        <CFormInput
                          className="custom-form-builder-theme__input"
                          value={questionObj?.label}
                          onChange={(e) =>
                            setQuestionObj((prev) => ({
                              ...prev,
                              label: e.target.value,
                            }))
                          }
                          type="text"
                          id="questionLabelInput"
                          placeholder="Enter question..."
                        />
                      </div>

                      <div className="w-100">
                        <CFormCheck
                          checked={questionObj?.isMultiple}
                          onChange={() =>
                            setQuestionObj((prev) => ({
                              ...prev,
                              isMultiple: !questionObj.isMultiple,
                            }))
                          }
                          id="flexCheckTextInput"
                          label="Allow multiple values"
                        />
                      </div>
                      <div className="w-100">
                        <CFormCheck
                          checked={questionObj?.historyOfDiagnosis}
                          onChange={() =>
                            setQuestionObj((prev) => ({
                              ...prev,
                              historyOfDiagnosis: !questionObj.historyOfDiagnosis,
                            }))
                          }
                          id="HODCheckTextInput"
                          label="History of Diagnosis Question"
                        />
                      </div>

                      <div className="w-100 mb-2">
                        <p className="font-weight-medium mb-2">Tooltip / Suggestions</p>
                        <CFormInput
                          className="custom-form-builder-theme__input"
                          value={questionObj?.toolTipValue}
                          onChange={(e) => {
                            setQuestionObj((prev) => ({
                              ...prev,
                              toolTipValue: e.target.value,
                            }))
                          }}
                          type="text"
                          id="questionEmailInput"
                          placeholder=""
                        />
                      </div>

                      <div className="w-100">
                        <p className="font-weight-medium mb-2">Description</p>
                        <CFormTextarea
                          className="custom-form-builder-theme__textarea"
                          value={questionObj?.providerInfo}
                          onChange={(e) => {
                            setQuestionObj((prev) => ({
                              ...prev,
                              providerInfo: e.target.value,
                            }))
                          }}
                          id="providerInfoTextArea"
                          placeholder="Enter description here..."
                        />
                      </div>
                    </div>
                    <div className="" style={{ position: 'relative', height: '68vh' }}></div>
                  </div>
                )}
                {activeTab === 'options' && (
                  <QuestionDropdownOptions
                    dropdownInput={questionObj}
                    setDropdownInput={setQuestionObj}
                    handleAddOptions={handleAddOptions}
                    handleChangeOption={handleChangeOption}
                    fillYesNo={fillYesNo}
                    setFillYesNo={setFillYesNo}
                    labList={labList}
                    medicationData={medicationData}
                    imagingData={imagingData}
                    diagnosiss={diagnosiss}
                    openQuestionModal={openQuestionModal}
                    styling={styling}
                    diagnosisForNested={diagnosisForNested}
                    currentTextInputs={currentTextInputs}
                    setCurrentTextInputs={setCurrentTextInputs}
                    addQuestions={addQuestions}
                  />
                )}
                {activeTab === 'assessment' && (
                  <QuestionDropdownTSTab
                    dropdownInput={questionObj}
                    labList={labList}
                    medicationData={medicationData}
                    imagingData={imagingData}
                    diagnosiss={diagnosiss}
                    diagnosisForNested={diagnosisForNested}
                    setDropdownInput={setQuestionObj}
                    options={dropdownInput.options}
                    addFormMade={addFormMade}
                    handleAutoSave={handleAutoSave}
                  />
                )}
              </div>
            </CCol>

            <CCol xs={12} md={6} className="custom-form-builder-theme__builder-preview d-flex align-items-center p-4 flex-column justify-content-center position-sticky" style={{ top: '80px', left: 0, zIndex: 10 }}>
              <QuestionDropdownPreview
                dropdownInput={questionObj}
                previewActiveTab={previewActiveTab}
                setDropdownInput={setQuestionObj}
                setPreviewActiveTab={setPreviewActiveTab}
                selectOption={selectOption}
                setSelectOption={setSelectOption}
                setCurrentTextInputs={setCurrentTextInputs}
                currentTextInputs={currentTextInputs}
              />
              <div className="custom-form-builder-theme__builder-actions py-4 d-flex justify-content-start gap-2 position-sticky bottom-0 left-0 w-full">
                <CButton
                  color="primary"
                  className="px-4 ui-action-btn ui-action-btn--primary"
                  onClick={() => {
                    handleSave()
                  }}
                >
                  Save
                </CButton>
                <CButton
                  color="secondary"
                  className="px-4 ui-action-btn ui-action-btn--secondary"
                  onClick={() => {
                    handleClose(), setIsBuilderVisible(false), setQuestionType(false)
                  }}
                >
                  Close
                </CButton>
              </div>
            </CCol>
          </div>
        </div>
      </motion.div>
    )
};

export default QuestionDropdownBuilder;
